// import { Injectable } from '@angular/core';
// import createAuth0Client, {
//   GetTokenSilentlyOptions,
//   GetUserOptions,
// } from '@auth0/auth0-spa-js';
// import Auth0Client from '@auth0/auth0-spa-js/dist/typings/Auth0Client';
// import {
//   from,
//   of,
//   Observable,
//   BehaviorSubject,
//   combineLatest,
//   throwError,
// } from 'rxjs';
// import {
//   tap,
//   catchError,
//   concatMap,
//   shareReplay,
//   switchMap,
//   map,
// } from 'rxjs/operators';
// import { Router } from '@angular/router';
// import { environment } from '../../../environments/environment';
// import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// import { UserProfileData } from 'src/app/interfaces/user-profile-data';
// @Injectable({
//   providedIn: 'root',
// })
// export class AuthService {
//   isFirstLogin: boolean = true;
//   userRole: string = '';
//   // Create an observable of Auth0 instance of client
//   auth0Client$ = (
//     from(
//       createAuth0Client({
//         audience: environment.authConfig.audience,
//         domain: environment.authConfig.domain,
//         client_id: environment.authConfig.clientID,
//         redirect_uri: environment.authConfig.redirectUri,
//         scope: environment.authConfig.scope,
//       })
//     ) as Observable<Auth0Client>
//   ).pipe(
//     shareReplay(1), // Every subscription receives the same shared value
//     catchError((err) => throwError(() => new Error('auth | ' + err)))
//   );
//   // Define observables for SDK methods that return promises by default
//   // For each Auth0 SDK method, first ensure the client instance is ready
//   // concatMap: Using the client instance, call SDK method; SDK returns a promise
//   // from: Convert that resulting promise into an observable
//   isAuthenticated$ = this.auth0Client$.pipe(
//     concatMap((client: Auth0Client) => from(client.isAuthenticated())),
//     tap((res) => (this.loggedIn = res))
//   );
//   handleRedirectCallback$ = this.auth0Client$.pipe(
//     concatMap((client: Auth0Client) => from(client.handleRedirectCallback()))
//   );
//   // Create subject and public observable of user profile data
//   public userProfileSubject$ = new BehaviorSubject<any>(null);
//   userProfile$ = this.userProfileSubject$.asObservable();
//   // Create a local property for login status
//   loggedIn: boolean = false;
//   private permissionsSubject$ = new BehaviorSubject<string[]>([]);
//   permissions$ = this.permissionsSubject$.asObservable();

//   cachePermissions(permissions: string[]) {
//     this.permissionsSubject$.next(permissions);
//   }

//   getPermissions(): Observable<string[]> {
//     return this.permissions$;
//   }

//   constructor(public router: Router, private http: HttpClient) {
//     // On initial load, check authentication state with authorization server
//     // Set up local auth streams if user is already authenticated
//     this.localAuthSetup();
//     // Handle redirect from Auth0 login
//     this.handleAuthCallback();
//   }

//   getUserProfile$(): Observable<any> {
//     return this.userProfile$;
//   }

//   // When calling, options can be passed if desired
//   // https://auth0.github.io/auth0-spa-js/classes/auth0client.html#getuser
//   getUser$(options?: GetUserOptions | undefined): Observable<any> {
//     return this.auth0Client$.pipe(
//       concatMap((client: Auth0Client) => from(client.getUser(options))),
//       tap((user) => this.userProfileSubject$.next(user))
//     );
//   }

//   // When calling, options can be passed if desired
//   // https://auth0.github.io/auth0-spa-js/classes/auth0client.html#gettokensilently
//   getTokenSilently$(
//     options?: GetTokenSilentlyOptions & { detailedResponse: true }
//   ): Observable<string> {
//     return this.auth0Client$.pipe(
//       concatMap((client: Auth0Client) => from(client.getTokenSilently(options)))
//     );
//   }

//   /* istanbul ignore next */
//   getPermissionsByRole(roles: string[]): Observable<any> {
//     const httpUrl = `${environment.apiUrl2}/userpermissions/GetUserPermissions`;

//     return this.getTokenSilently$().pipe(
//       switchMap((accessToken: string) => {
//         // Create headers inside the method
//         const headers = new HttpHeaders({
//           'content-type': 'application/json',
//           Authorization: `Bearer ${accessToken}`,
//         });

//         const rolesString = roles.join(',');
//         const params = new HttpParams().set('roles', rolesString); // Add the role as a query parameter

//         const options = {
//           headers: headers,
//           params: params, // Set the params in the options object
//         };

//         return this.http.get<{ rolePermissions: any[] }>(httpUrl, options).pipe(
//           map((response) =>
//             response.rolePermissions.flatMap((rolePermission) =>
//               rolePermission.permissions.map(
//                 (permission: { permissionDesc: any }) =>
//                   permission.permissionDesc
//               )
//             )
//           ),
//           tap((permissions) => {
//             // console.log(' WHATTPermissions:', permissions);
//             this.cachePermissions(permissions);
//           })
//         );
//       })
//     );
//   }

//   /* istanbul ignore next */
//   localAuthSetup() {
//     // This should only be called on app initialization
//     // Set up local authentication streams
//     const checkAuth$ = this.isAuthenticated$.pipe(
//       concatMap((loggedIn: boolean) => {
//         if (loggedIn) {
//           // If authenticated, get user and set in app
//           // NOTE: you could pass options here if needed
//           return this.getUser$().pipe(
//             switchMap((userProfile: UserProfileData) => {
//               const roles: string[] =
//                 userProfile['http://allegion.com/claims/roles'];
//               console.log('Roles:', roles);

//               if (roles.includes('ZentraAdmin')) {
//                 // If the user has the Onboarding role, redirect to the onboarding form
//                 this.router.navigate(['/zentra-subscriptions']);
//               } else if (roles.includes('TechSupport')) {
//                 // If the user has the FullControl role, redirect to the landing page
//                 this.router.navigate(['/credential-library']);
//               } else {
//                 // For other roles or no specific role, redirect to the general landing page or perform other logic
//                 this.router.navigate(['/landing']); // Adjust as needed
//               }
//               // })
//               // );

//               return this.getPermissionsByRole(roles).pipe(
//                 tap((permissions) => {
//                   this.cachePermissions(permissions);
//                   console.log('Permissions:', permissions);
//                 })
//               );
//             })
//           );
//         }
//         // If not authenticated, return stream that emits 'false'
//         return of(loggedIn);
//       })
//     );
//     checkAuth$.subscribe();
//   }

//   login(redirectPath: string = '/landing') {
//     // A desired redirect path can be passed to login method
//     // (e.g., from a route guard)
//     // Ensure Auth0 client instance exists
//     this.auth0Client$.subscribe((client: Auth0Client) => {
//       // Call method to log in
//       client.loginWithRedirect({
//         redirect_uri: environment.authConfig.redirectUri,
//         appState: { target: redirectPath },
//       });
//     });
//   }

//   sso(redirectPath: string = '/landing') {
//     // A desired redirect path can be passed to login method
//     // (e.g., from a route guard)
//     // Ensure Auth0 client instance exists
//     this.auth0Client$.subscribe((client: Auth0Client) => {
//       // Call method to log in

//       client.loginWithRedirect({
//         redirect_uri: environment.authConfig.redirectUri,
//         appState: { target: redirectPath },
//         prompt: 'none',
//       });
//     });
//   }
//   /* istanbul ignore next */
//   // getLandingPageByRole(role: string): string {
//   //   if (role === 'FullControl' || role === 'ViewOnly') {
//   //     return '/landing';
//   //   } else if (role === 'Onboarding') {
//   //     return '/onboarding-form';
//   //   } else {
//   //     throw new Error(`Error: Role "${role}" not found`);
//   //   }
//   // }
//   /* istanbul ignore next */
//   handleAuthCallback() {
//     // Call when app reloads after user logs in with Auth0
//     const params = window.location.search;
//     if (params.includes('code=') && params.includes('state=')) {
//       let targetRoute: string; // Path to redirect to after login processsed
//       const authComplete$ = this.handleRedirectCallback$.pipe(
//         // Have client, now call method to handle auth callback redirect
//         tap((cbRes) => {
//           // Get and set target redirect route from callback results
//           targetRoute =
//             cbRes.appState && cbRes.appState.target
//               ? cbRes.appState.target
//               : '/callback';
//         }),
//         concatMap(() =>
//           // Redirect callback complete; get user and login status
//           combineLatest([this.getUser$(), this.isAuthenticated$])
//         )
//       );
//       // Subscribe to authentication completion observable
//       // Response will be an array of user and login status
//       authComplete$.subscribe(([user, loggedIn]) => {
//         // Get user roles from the user profile
//         const roles: string[] = user['http://allegion.com/claims/roles'] || [];

//         // Retrieve the latest permissions from permissionsSubject$
//         const permissions = this.permissionsSubject$.getValue(); // Gets the current value

//         // Set targetRoute to the default landing page
//         // targetRoute = '/'; // Replace this with the default landing page route for other roles

//         // Update the targetRoute based on user roles
//         roles.forEach((role) => {
//           if (
//             role === 'FullControl' ||
//             role === 'ViewOnly' ||
//             role === 'APIUser' ||
//             role === 'MobileCredUser'
//           ) {
//             // targetRoute = this.getLandingPageByRole(role);
//           }
//         });

//         // Redirect to target route after callback processing
//         this.router.navigate([targetRoute]);
//         // Log user profile data
//         // console.log(user, 'user');

//         // Call localAuthSetup to get permissions for the new user
//         this.localAuthSetup();
//       });
//     }
//   }

//   logout() {
//     // Ensure Auth0 client instance exists
//     this.auth0Client$.subscribe((client: Auth0Client) => {
//       // Call method to log out
//       client.logout({
//         client_id: environment.authConfig.clientID,
//         returnTo: environment.authConfig.logoutUrl,
//       });

//       // Clear permissions cache and update user profile subject
//       this.cachePermissions([]);
//       this.userProfileSubject$.next(null);
//     });
//   }

//   noAccess(url: string) {
//     this.router.navigate([url]);
//   }

//   roles(): Observable<any> {
//     let userRoles = new Observable<any>((rolesList) => {
//       rolesList.next({
//         roles: [
//           'FullControl',
//           'ViewOnly',
//           'TechSupport',
//           'Onboarding',
//           'APIUser',
//           'MobileCredUser',
//           'ZentraAdmin',
//         ],
//       });
//     });
//     return userRoles;
//   }
// }

import { Injectable } from '@angular/core';
import createAuth0Client, {
  GetTokenSilentlyOptions,
  GetUserOptions,
} from '@auth0/auth0-spa-js';
import Auth0Client from '@auth0/auth0-spa-js/dist/typings/Auth0Client';
import {
  from,
  of,
  Observable,
  BehaviorSubject,
  combineLatest,
  throwError,
} from 'rxjs';
import {
  tap,
  catchError,
  concatMap,
  shareReplay,
  switchMap,
  map,
} from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { UserProfileData } from 'src/app/interfaces/user-profile-data';
import { Wholesaler } from 'src/app/interfaces/Wholesaler.interface';
import { MaxioProductComponentMapping, ZentraConnectSiteStatus } from 'src/app/interfaces/subProduct.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  isFirstLogin: boolean = true;
  userRole: string = '';
  // Create an observable of Auth0 instance of client
  auth0Client$ = (
    from(
      createAuth0Client({
        audience: environment.authConfig.audience,
        domain: environment.authConfig.domain,
        client_id: environment.authConfig.clientID,
        redirect_uri: environment.authConfig.redirectUri,
        scope: environment.authConfig.scope,
      })
    ) as Observable<Auth0Client>
  ).pipe(
    shareReplay(1), // Every subscription receives the same shared value
    catchError((err) => throwError(() => new Error('auth | ' + err)))
  );

  // Define observables for SDK methods that return promises by default
  isAuthenticated$ = this.auth0Client$.pipe(
    concatMap((client: Auth0Client) => from(client.isAuthenticated())),
    tap((res) => (this.loggedIn = res))
  );

  handleRedirectCallback$ = this.auth0Client$.pipe(
    concatMap((client: Auth0Client) => from(client.handleRedirectCallback()))
  );

  // Create subjects and public observables for user profile data, roles, and permissions
  public userProfileSubject$ = new BehaviorSubject<any>(null);
  userProfile$ = this.userProfileSubject$.asObservable();

  private permissionsSubject$ = new BehaviorSubject<string[]>([]);
  permissions$ = this.permissionsSubject$.asObservable();

  private readonly rolesFromPermsSubject$ = new BehaviorSubject<string[]>([]);
  rolesFromPerms$ = this.rolesFromPermsSubject$.asObservable();

  private readonly combinedRolesSubject$ = new BehaviorSubject<string[]>([]);
  combinedRoles$ = this.combinedRolesSubject$.asObservable();
  /* istanbul ignore next */
  private readonly wholesalersSubject$ = new BehaviorSubject<Wholesaler[]>([]);
  wholesalers$ = this.wholesalersSubject$.asObservable();

  /* istanbul ignore next */
  private readonly productComponentMappingSubject$ = new BehaviorSubject<MaxioProductComponentMapping | null>(null);

  // Pre-computed product → component lookup built at login time.
  // Plain Map<productId, array of variant entries> — no BehaviorSubject, no JSON parsing at call time.
  private _productComponentLookup = new Map<
    number,
    Array<{ isExistingZentraConnectSite: ZentraConnectSiteStatus; optionalIds: number[]; mandatoryIds: number[]; qtyEditableIds: number[] }>
  >();

  // Flat list of component IDs that require the extra Zentra Connect fields
  // (Number of Units / Number of Perimeter/Amenity), regardless of product.
  private _connectComponentIds: number[] = [];

  // Add a helper to get the current value without an observable if needed
  /* istanbul ignore next */
  getWholesalers(): Wholesaler[] {
    return this.wholesalersSubject$.getValue();
  }

  /* istanbul ignore next */
  getConnectComponentIds(): number[] {
    return this._connectComponentIds;
  }

  /* istanbul ignore next */
  getComponentEntries(
    productId: number
  ): Array<{ isExistingZentraConnectSite: ZentraConnectSiteStatus; optionalIds: number[]; mandatoryIds: number[]; qtyEditableIds: number[] }> {
    return this._productComponentLookup.get(productId) ?? [];
  }

  loggedIn: boolean = false;

  constructor(public router: Router, private readonly http: HttpClient) {
    this.localAuthSetup();
    this.handleAuthCallback();
  }

  cachePermissions(permissions: string[]) {
    this.permissionsSubject$.next(permissions);
  }

  cacheRolesFromPerms(roles: string[]) {
    this.rolesFromPermsSubject$.next(roles);
  }

  cacheCombinedRoles(roles: string[]) {
    this.combinedRolesSubject$.next(roles);
  }

  getPermissions(): Observable<string[]> {
    return this.permissions$;
  }

  getRolesFromPerms(): Observable<string[]> {
    return this.rolesFromPerms$;
  }

  getAllRoles(): Observable<string[]> {
    return this.combinedRoles$;
  }

  getAllPermissions(): Observable<string[]> {
    return this.permissions$;
  }

  getUserProfile$(): Observable<any> {
    return this.userProfile$;
  }

  getUser$(options?: GetUserOptions | undefined): Observable<any> {
    return this.auth0Client$.pipe(
      concatMap((client: Auth0Client) => from(client.getUser(options))),
      tap((user) => this.userProfileSubject$.next(user))
    );
  }

  getTokenSilently$(
    options?: GetTokenSilentlyOptions & { detailedResponse: true }
  ): Observable<string> {
    return this.auth0Client$.pipe(
      concatMap((client: Auth0Client) => from(client.getTokenSilently(options)))
    );
  }

  /* istanbul ignore next */
  getPermissionsByRole(roles: string[]): Observable<any> {
    const httpUrl = `${environment.apiUrl2}/userpermissions/GetUserPermissions`;

    return this.getTokenSilently$().pipe(
      switchMap((accessToken: string) => {
        const headers = new HttpHeaders({
          'content-type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        });

        const rolesString = roles.join(',');
        const params = new HttpParams().set('roles', rolesString);
        const options = { headers, params };

        return this.http
          .get<{ rolePermissions: any[]; wholesalers: Wholesaler[]; maxioProductComponentMapping: MaxioProductComponentMapping; mandatoryFieldsConnectComponentIds: number[] }>(
            httpUrl,
            options
          )
          .pipe(
            map((response) => {
              // 1. Extract Roles and Permissions (Existing logic)
              const rolesFromPerms = response.rolePermissions.map(
                (rolePermission) => rolePermission.role
              );
              const permissionsFromPerms = response.rolePermissions.flatMap(
                (rolePermission) =>
                  rolePermission.permissions.map(
                    (permission: { permissionDesc: any }) =>
                      permission.permissionDesc
                  )
              );

              // 2. Extract and Cache Wholesalers (Existing logic)
              const wholesalers = response.wholesalers || [];
              this.wholesalersSubject$.next(wholesalers);

              // 2b. Extract and Cache Zentra Connect component IDs
              this._connectComponentIds = (
                response.mandatoryFieldsConnectComponentIds ?? []
              ).map(Number);

              // 3. Extract and Cache Product-Component Mapping
              const mapping = response.maxioProductComponentMapping ?? null;
              this.productComponentMappingSubject$.next(mapping);
              // Pre-compute a plain Map keyed by productId for reliable access at click time
              const lookup = new Map<
                number,
                Array<{ isExistingZentraConnectSite: ZentraConnectSiteStatus; optionalIds: number[]; mandatoryIds: number[]; qtyEditableIds: number[] }>
              >();
              if (mapping) {
                for (const entry of mapping.mapping) {
                  const pid = Number(entry.productId);
                  const list = lookup.get(pid) ?? [];
                  list.push({
                    isExistingZentraConnectSite: entry.isExistingZentraConnectSite ?? null,
                    optionalIds: (entry.optionalcomponentIds ?? []).map(Number),
                    mandatoryIds: (entry.mandatoryComponentIds ?? []).map(Number),
                    qtyEditableIds: (entry.qtyEditableComponentIds ?? []).map(Number),
                  });
                  lookup.set(pid, list);
                }
              }
              this._productComponentLookup = lookup;

              this.cacheRolesFromPerms(rolesFromPerms);
              this.cachePermissions(permissionsFromPerms);

              return {
                roles: rolesFromPerms,
                permissions: permissionsFromPerms,
                wholesalers: wholesalers,
              };
            })
          );
      })
    );
  }

  fetchAndMergeRolesAndPermissions(existingRoles: string[]): Observable<void> {
    return this.getPermissionsByRole(existingRoles).pipe(
      map(({ roles: rolesFromPerms }) => {
        const combinedRoles = Array.from(
          new Set([...existingRoles, ...rolesFromPerms])
        );
        this.cacheCombinedRoles(combinedRoles);
      })
    );
  }

  localAuthSetup() {
    const checkAuth$ = this.isAuthenticated$.pipe(
      concatMap((loggedIn: boolean) => {
        if (loggedIn) {
          return this.getUser$().pipe(
            switchMap((userProfile: UserProfileData) => {
              const roles: string[] =
                userProfile['http://allegion.com/claims/roles'];
              console.log('Roles:', roles);

              if (roles.includes('ZentraAdmin')) {
                this.router.navigate(['/zentra-subscriptions']);
              } else if (roles.includes('TechSupport')) {
                this.router.navigate(['/credential-library']);
              } else if (roles.includes('OverturAdmin')) {
                this.router.navigate(['/overtur-admin-subscriptions']);
              } else if (roles.includes('SATAdmin')) {
                this.router.navigate(['/sat-subscriptions']);
              } else {
                this.router.navigate(['/landing']);
              }

              return this.fetchAndMergeRolesAndPermissions(roles).pipe(
                tap(() =>
                  console.log('Roles and permissions merged successfully.')
                )
              );
            })
          );
        }
        return of(loggedIn);
      })
    );
    checkAuth$.subscribe();
  }

  login(redirectPath: string = '/landing', screenHint?: string) {
    this.auth0Client$.subscribe((client: Auth0Client) => {
      const options: any = {
        redirect_uri: environment.authConfig.redirectUri,
        appState: { target: redirectPath },
      };
      if (screenHint) {
        options['screen_hint'] = screenHint;
      }
      client.loginWithRedirect(options);
    });
  }

  sso(redirectPath: string = '/landing') {
    this.auth0Client$.subscribe((client: Auth0Client) => {
      client.loginWithRedirect({
        redirect_uri: environment.authConfig.redirectUri,
        appState: { target: redirectPath },
        prompt: 'none',
      });
    });
  }

  handleAuthCallback() {
    const params = window.location.search;
    if (params.includes('code=') && params.includes('state=')) {
      let targetRoute: string;
      const authComplete$ = this.handleRedirectCallback$.pipe(
        tap((cbRes) => {
          targetRoute =
            cbRes.appState && cbRes.appState.target
              ? cbRes.appState.target
              : '/callback';
        }),
        concatMap(() => combineLatest([this.getUser$(), this.isAuthenticated$]))
      );
      authComplete$.subscribe(([user, _loggedIn]) => {
        const roles: string[] = user['http://allegion.com/claims/roles'] ?? [];

        roles.forEach((role) => {
          if (
            role === 'FullControl' ||
            role === 'ViewOnly' ||
            role === 'APIUser' ||
            role === 'MobileCredUser'
          ) {
          }
        });

        this.router.navigate([targetRoute]);

        this.localAuthSetup();
      });
    }
  }

  logout() {
    this.auth0Client$.subscribe((client: Auth0Client) => {
      client.logout({
        client_id: environment.authConfig.clientID,
        returnTo: environment.authConfig.logoutUrl,
      });

      this.cachePermissions([]);
      this.wholesalersSubject$.next([]);
      this.productComponentMappingSubject$.next(null);
      this._productComponentLookup.clear();
      this._connectComponentIds = [];
      this.userProfileSubject$.next(null);
    });
  }

  noAccess(url: string) {
    this.router.navigate([url]);
  }

  roles(): Observable<any> {
    let userRoles = new Observable<any>((rolesList) => {
      rolesList.next({
        roles: [
          'FullControl',
          'ViewOnly',
          'TechSupport',
          'Onboarding',
          'APIUser',
          'MobileCredUser',
          'ZentraAdmin',
        ],
      });
    });
    return userRoles;
  }
}
